import {
  CLEAR_ACCOUNT_ADDRESSES,
  FETCH_ADDRESSES,
  FETCH_ADDRESSES_FULFILLED,
  FETCH_ADDRESSES_REJECTED,
} from './actionTypes';
import {
  AddressesType,
  ClearAccountAddressesAction,
  FetchAddressesAction,
  FetchAddressesFulfilledAction,
  FetchAddressesRejectedAction,
} from './types';

const fetchAddresses = (
  pageSize: number,
  startItem: number,
): FetchAddressesAction => ({
  type: FETCH_ADDRESSES,
  payload: {
    startItem,
    pageSize,
  },
});

const fetchAddressesFulfilled = (
  response: AddressesType,
): FetchAddressesFulfilledAction => ({
  type: FETCH_ADDRESSES_FULFILLED,
  payload: {
    data: response,
  },
});

const fetchAddressesRejected = (
  error: ErrorType,
): FetchAddressesRejectedAction => ({
  type: FETCH_ADDRESSES_REJECTED,
  payload: {
    error,
  },
});

const clearAccountAddresses = (): ClearAccountAddressesAction => ({
  type: CLEAR_ACCOUNT_ADDRESSES,
});

export {
  clearAccountAddresses,
  fetchAddresses,
  fetchAddressesFulfilled,
  fetchAddressesRejected,
};
